import { Link } from "react-router-dom";
import type { Product } from "@shared/types";
import { formatMoney } from "@/lib/format";
import { useWishlist } from "@/lib/wishlist";
import { HeartIcon } from "./icons";

export function ProductCard({ product }: { product: Product }) {
  const image = product.images[0];
  const { has, toggle } = useWishlist();
  const liked = has(product.id);

  return (
    <Link to={`/product/${product.slug}`} className="flex w-full flex-col gap-2">
      <div className="relative aspect-[164/190] w-full overflow-hidden rounded-t-xl rounded-b-md bg-stone-100">
        {image ? (
          <img src={image.url} alt={image.alt || product.name} className="h-full w-full object-cover" loading="lazy" />
        ) : (
          <div className="flex h-full w-full items-center justify-center text-stone-500">
            <span className="font-display text-sm">Allthingsnew</span>
          </div>
        )}
        {product.isNew && (
          <span className="absolute left-2.5 top-2.5 rounded bg-wine px-2 py-1 text-[10px] font-bold uppercase tracking-wide text-white">
            New
          </span>
        )}
        <button
          type="button"
          aria-label={liked ? "Remove from wishlist" : "Add to wishlist"}
          className={`absolute right-2.5 top-2.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-white/90 shadow-card ${liked ? "text-wine" : "text-ink"}`}
          onClick={(e) => {
            e.preventDefault();
            toggle(product.id);
          }}
        >
          <HeartIcon filled={liked} width={15} height={15} className="shrink-0" />
        </button>
      </div>
      <div className="flex flex-col gap-0.5">
        <span className="text-[11px] font-semibold uppercase tracking-wide text-stone-500">Allthingsnew</span>
        <span className="line-clamp-2 text-sm text-ink">{product.name}</span>
        <div className="flex items-center gap-2">
          <span className="text-base font-semibold text-ink">{formatMoney(product.priceCents, product.currency)}</span>
          {product.compareAtPriceCents && (
            <span className="text-xs text-stone-500 line-through">
              {formatMoney(product.compareAtPriceCents, product.currency)}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}
